export default "__VITE_ASSET__OOsnh8Wk__"